import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import { CIRCUIT_PATH, ROUTE_PATH } from '../../../../config/paths';
import { clearRoute, getRoute, putRoute } from '../../../../actions';
import RouteForm from './RouteForm';

const EditRoute = ({
  breadcrumbs,
  dispatchClearRoute,
  dispatchGetRoute,
  dispatchPutRoute,
  match: {
    params: { id: routeId },
  },
  loading,
  route,
}) => {
  useLayoutEffect(() => {
    dispatchGetRoute({ routeId });

    return () => dispatchClearRoute();
  }, []);

  const onSubmit = (formValues) => {
    const originalRoute = route.toJS();

    const routeSegmentList = originalRoute.routeSegmentList.map(
      (originalSegment, index) => ({
        ...originalSegment,
        segmentId: formValues.routeSegmentList[index].segmentId.value,
        segmentOrder: index,
      }),
    );

    const payload = {
      ...originalRoute,
      name: formValues.name,
      description: formValues.description,
      hotZone: formValues.hotZone ? formValues.hotZone : false,
      coldZone: formValues.coldZone ? formValues.coldZone : false,
      steepRoute: formValues.steepRoute ? formValues.steepRoute : false,
      flatRoute: formValues.flatRoute ? formValues.flatRoute : false,
      isLong: formValues.isLong ? formValues.isLong : false,
      routeSegmentList,
    };

    dispatchPutRoute(routeId, payload);
  };

  const generateInitialValues = ({
    name,
    description,
    routeSegmentList,
    isOneWay,
    isMaciva,
    isLong,
  }) => ({
    name,
    description,
    isOneWay,
    isMaciva,
    isLong,
    routeSegmentList: routeSegmentList.map((routeSegment) => ({
      segmentId: {
        value: routeSegment.segmentId,
        label: `${routeSegment.segment.sourceLocation.name} - ${routeSegment.segment.destinationLocation.name}`,
      },
    })),
  });

  let content;

  if (loading) content = <Loader />;
  else if (route.isEmpty())
    content = <NoDataResource returnPage={CIRCUIT_PATH} />;
  else
    content = (
      <RouteForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(route.toJS())}
        edit
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Ruta"
      subtitle="Editar Ruta"
      content={content}
    />
  );
};

EditRoute.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearRoute: PropTypes.func.isRequired,
  dispatchGetRoute: PropTypes.func.isRequired,
  dispatchPutRoute: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  route: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditRoute.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearRoute: clearRoute,
  dispatchGetRoute: getRoute,
  dispatchPutRoute: putRoute,
};

const mapStateToProps = (
  { RouteUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Rutas',
      href: ROUTE_PATH,
    },
    {
      text: 'Ver',
      href: `${ROUTE_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  route: RouteUnit.Route.getIn(['current', 'content']),
  loading: !RouteUnit.Route.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditRoute);
